/* CSS */
import "@js/parts/css";

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}

/* Project helper imports */
import layoutCalcs from '@js/helpers/LayoutCalcs';

/* Project modules imports */
import HeaderScroll from '@js/modules/HeaderScroll';
import MobileNav from '@js/modules/MobileNav';

/* Document ready */
document.addEventListener('DOMContentLoaded', () => {

    // Vars
    const HTML = document.documentElement;
    const HTML_CLASSLIST = HTML.classList;

    // Layout calculcations
    layoutCalcs.init({
        header: {
            selector: '.header',
            var: '--hh'
        }
    });

    // Header scroll
    new HeaderScroll({
        offset: layoutCalcs.get('header')
    });

    // Mobile nav
    new MobileNav();

    // Current year
    const yearElement = document.querySelector('.current-year');
    if (yearElement) {
        yearElement.textContent = new Date().getFullYear();
    }

});


